import { OwnerStateThemeType } from './'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

export default {
  MuiSelect: {
    defaultProps: {
      IconComponent: ExpandLessIcon,
    },
    variants: [
      {
        props: { variant: 'outlined', size: 'small' },
        style: ({}: OwnerStateThemeType) => ({
          '& .MuiSelect-select': {
            padding: '7px 11px !important',
          },
        }),
      },
      {
        props: { variant: 'outlined', size: 'small', multiple: true },
        style: ({}: OwnerStateThemeType) => ({
          '& .MuiSelect-select.MuiSelect-multiple': {
            padding: '7px 11px !important',
          },
        }),
      },
    ],
    styleOverrides: {
      select: ({ theme }: OwnerStateThemeType) => ({
        color: theme.palette.grey[900],
        fontWeight: 400,
        backgroundColor: theme.palette.common.white,

        '&:hover': {
          backgroundColor: theme.palette.common.white,
        },
        '&.Mui-focused': {
          backgroundColor: theme.palette.common.white,
        },
      }),
      icon: ({ theme }: OwnerStateThemeType) => ({
        color: theme.palette.grey[900],
        fontSize: '18px',
        transition: '0.2s',
      }),
      root: ({ theme }: OwnerStateThemeType) => ({
        borderRadius: '8px',
        backgroundColor: `${theme.palette.common.white} !important`,
        minHeight: '35.7px',

        '& .MuiTypography-root': {
          color: theme.palette.grey[900],
          fontWeight: 400,
        },

        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.error.main} !important`,
        },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          transition: '0.2s',
          border: '1px solid',
          borderColor: theme.palette.success.main,
        },

        '&:not(.Mui-focused):not(.Mui-disabled):not(.Mui-error):hover .MuiOutlinedInput-notchedOutline':
          {
            borderColor: `${theme.palette.grey[900]}`,
          },
      }),
    },
  },
}
